import React from 'react';

const ContactQuickLink = () => {
  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="max-w-4xl mx-auto w-full text-center">
        <div className="mb-12">
          <i className="fas fa-envelope-open-text text-6xl text-blue-600 mb-8 block"></i>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Ready to Enhance Your Safety Systems?
          </h2>
          <p className="text-xl text-gray-600 mb-12">
            Let's discuss how we can help you achieve functional safety excellence
          </p>
        </div>
        
        <a 
          href="mailto:sales@functionalsafetysystem.com"
          className="bg-blue-600 text-white px-12 py-5 rounded-lg text-xl font-semibold hover:bg-blue-700 transform hover:-translate-y-1 transition-all duration-300 shadow-xl hover:shadow-2xl inline-block"
        >
          Get in Touch
        </a>
        
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto">
          <div className="text-center">
            <i className="fas fa-envelope text-3xl text-blue-600 mb-4 block"></i>
            <h3 className="font-semibold text-gray-900 mb-2">Email Us</h3>
            <p className="text-gray-600">sales@functionalsafetysystem.com</p>
          </div>
          <div className="text-center">
            <i className="fas fa-calendar-check text-3xl text-blue-600 mb-4 block"></i>
            <h3 className="font-semibold text-gray-900 mb-2">Schedule Meeting</h3>
            <p className="text-gray-600">Book a consultation</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactQuickLink;
